import React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide, { SlideProps } from '@mui/material/Slide'
import { Box } from '@mui/material'
import FullScreenDialogHeader from './FullScreenDialogHeader'

const Transition = React.forwardRef<HTMLDivElement, SlideProps>(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

interface FullScreenDialogProps {
  show: boolean
  onHide: () => void
  ariaLabelBy: string
  hasCloseBtn?: boolean
  customHeaderStyle?: React.CSSProperties
  headerContent?: React.ReactNode
  customBodyStyle?: React.CSSProperties
  bodyContent?: React.ReactNode
}

const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  show,
  onHide,
  ariaLabelBy,
  hasCloseBtn,
  customHeaderStyle,
  headerContent,
  customBodyStyle,
  bodyContent,
}) => {
  return (
    <Dialog
      fullScreen
      open={show}
      onClose={onHide}
      aria-labelledby={ariaLabelBy}
      TransitionComponent={Transition}
    >
      <FullScreenDialogHeader
        hasCloseBtn={hasCloseBtn}
        customHeaderStyle={customHeaderStyle}
        headerContent={headerContent}
        onHide={onHide}
      />
      <Box sx={{ ...customBodyStyle }}>{bodyContent}</Box>
    </Dialog>
  )
}

export default FullScreenDialog
